export const USE_TIME_TYPE = Object.freeze([{
        label: "全部",
        value: "all",
    },
    {
        label: "工作日",
        value: "workday",
    },
    {
        label: "节假日",
        value: "holiday",
    },
]);

export const DEDUCTION_MODE = Object.freeze([{
        label: "减前段时间",
        value: "Before"
    },
    {
        label: "减后段时间",
        value: "After"
    },
]);

export const VALID_PERIOD_TYPE = Object.freeze([{
        label: "不限制",
        value: "NoLimt"
    },
    {
        label: "时刻起",
        value: "CurrentTimeStart"
    },
    {
        label: "当天起",
        value: "CurrentDayStart"
    },
    {
        label: "发券当天",
        value: "IssueCouponDayStart"
    },
    {
        label: "发券当月",
        value: "IssueCouponMonthStart"
    },
    {
        label: "发券当周",
        value: "IssueCouponWeekStart"
    },
    {
        label: "发券当年",
        value: "IssueCouponYearStart"
    },
])

export const TRADE_MODE = Object.freeze([{
        label: "当面支付",
        value: "FaceToFace"
    },
    {
        label: "帐户低扣",
        value: "AccountDeduction"
    },
    {
        label: "周期结算",
        value: "PeriodSettle"
    }
])

export const COUPON_TYPE = Object.freeze([{
        label: "减免时长",
        value: "ReductTime"
    },
    {
        label: "减免次数",
        value: "ReductFrequency"
    },
    {
        label: "代金券",
        value: "Cash"
    },
    {
        label: "定额券",
        value: "Quota"
    },
    {
        label: "折扣券",
        value: "Discount"
    },
    {
        label: "限时免费",
        value: "LimitFree"
    },
    {
        label: "定时定额券",
        value: "FixTimeAndQuota"
    },
])

// export const RATING_TYPE=Object.freeze([{
//     label:'按次定额',value:''
// }])


export const TIME_LIMIT = Object.freeze([{
        label: "时刻起",
        value: "CurrentTimeStart"
    },
    {
        label: "当天起",
        value: "CurrentDayStart"
    },
])
export const COUPON_STATE = Object.freeze([{
        label: '创建',
        value: 'created'
    },
    {
        label: '已发放',
        value: 'issued'
    },
    {
        label: '已停止',
        value: 'stoped'
    },
    {
        label: '已过期',
        value: 'expired'
    }
])